export default {
  fundDetail: '資金明細',
  tradeStartDate: '取引開始日',
  tradeEndDate: '取引終了日',
  tradeNo: '取引番号',
  recharge: 'チャージ',
  rechargeLog: 'チャージレコード',
  relationOrderNo: '関連オーダー番号',
  tradeIntro: '取引の説明',
  tradeTime: '取引時間',
  tradeType: '取引タイプ',
  amount: '金額',
  address: '住所',
  balance: '残高',
  payPack: '梱包伝票支払',
  payOrder: '受注支払',
  compensate: 'に報いる',
  deduct: '引き落とし',
  withdrawal: '返金（現金引き出し）',
  fund1: '購入済控除',
  fund2: '返品返金',
  fund3: '異常控除',
  fund4: '同梱払い',
  fund5: '倉庫保管費',
  fund6: '検品オプション料金控除',
  fund7: '請求書の支払',
  fund8: '購入返金を取り消す',
  fund9: '検品払い戻しを取り消す',
  fund10: '交換詳細検品料',
  fund11: '倉庫保管料の払い戻し',
  fund12: '倉庫保管費',
  fund13: '国際送料返金',
  fund14: '上記金額は、1元＝{rate}円（レート）にて換算しております。',
  fund15: '国際送料・関税は本見積には含まれておらず、商品到着後に実費精算となります。',
  fund16: '手数料は（商品代金＋中国国内送料）× {rate}% にて算出しております。',
  fund17: '有効期限：本見積発行より1週間',
  fund18: '購入できず、返金不可',
  fund20: '検品料返金',
  fund21: '検品料返金',
  itemCost: '商品代金',
  domesticFreight: '中国国内送料',
  formulaPrefix: '手数料は',
  formulaSuffix: ' にて算出しております。',
  yen: '元',
  pricePrefix: '価格 >',
  yuan: '元',
  agentServiceFee: '代行手数料',
  totalPrice: '合計',
  paymentMethod: '支払い方法',
  bankPay: '銀行振込',
  useBalance: '残高を使用する',

};
